module.exports = __webpack_public_path__ + "static/media/tanque-rojo_old.7c4dcf39.svg";